module.exports = __webpack_public_path__ + "img/logo-black__181019.7a822ff3.jpg";